module.exports = __webpack_public_path__ + "img/open.6dcc01df.gif";